import { createSelector } from '@reduxjs/toolkit';
import { BusinessCaseType, StationsServed } from 'types';
import { StationsServedState } from './types';
import { RootState } from '../root-reducer';
/* eslint-disable no-underscore-dangle */
export const rootSelector = (state: RootState): StationsServedState => state.StationsServed;
export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const dataSelector = createSelector(rootSelector, (state) => state.data);
export const stationsByStationsServedSelector = createSelector(
  dataSelector,
  (data) => (departureStations: string[] | undefined, businessCaseItemName: BusinessCaseType) => {
    if (businessCaseItemName === 'PRE-OP-CANCELLATION' || businessCaseItemName === 'OP-CANCELLATION') {
      const stations = data?.filter((val) => val.uicStationCode !== data[data.length - 1].uicStationCode);

      return stations;
    }

    if (departureStations) {
      return data?.filter((departureStation) => departureStations.includes(departureStation.uicStationCode));
    }
    return null;
  }
);

export const servedStationFromUicSelector = createSelector(
  dataSelector,
  (data) => (uicId: string) => data && data.find((dataItem: StationsServed) => dataItem.uicStationCode === uicId)
);
export default {
  statusSelector,
  errorSelector,
  dataSelector,
  stationsByStationsServedSelector,
  servedStationFromUicSelector,
};
